import React, { useState } from "react";

import MainEmployee from "./MainEmployee";
import Employeedetails from "./Employeedetails";
import DateRangeComponent from "../../../reuseableComponents/DateRangeComponent";
import useMultiSelect from "../../../hooks/useMultiSelect";

const EmployeeWorking = ({
  hide = false,
  setCSVData,
  setCSVHeader,
  setCSVFileName,
  selectedDateRange,
  handleDateRangeChange,
}) => {
  const [SelectEmpIDData, setSelectEmpIDData] = useState(null);
  const [employeeList, setemployeeList] = useState([]);
  const {
    selectedItems: selectedEmployeeList,
    allOptionSelected: allEmployeeSelected,
    handleOptionClick: handleEmployeeClick,
  } = useMultiSelect(employeeList);

  const handleFilterDataChange = (SelectEmpID) => {
    setSelectEmpIDData(SelectEmpID);
  };

  return (
    <div>
      <div className="q-order-main-page">
        <MainEmployee
          hide={hide}
          onFilterDataChange={handleFilterDataChange}
          selectedEmployeeList={selectedEmployeeList}
          allEmployeeSelected={allEmployeeSelected}
          handleEmployeeClick={handleEmployeeClick}
          employeeList={employeeList}
          setemployeeList={setemployeeList}
        />
      </div>
      <DateRangeComponent onDateRangeChange={handleDateRangeChange} />
      <div className="q-order-main-page">
        <Employeedetails
          selectedDateRange={selectedDateRange}
          EmpId={SelectEmpIDData}
          setCSVData={setCSVData}
          setCSVHeader={setCSVHeader}
          setCSVFileName={setCSVFileName}
          selectedEmployeeList={selectedEmployeeList}
          allEmployeeSelected={allEmployeeSelected}
        />
      </div>
    </div>
  );
};

export default EmployeeWorking;
